import { saveTheme } from '../../components/dashboard-sale-indicators/theme'

export function setDashboard(state, dashboard) {
    state.dashboard = dashboard
}

// Fusiona una respuesta parcial de charts (solo las keys de DashboardSaleIndicatorsService::
// FILTERABLE_CHARTS que devuelve el backend cuando hay un filtro de drill-down activo) sobre
// dashboard.charts, sin tocar kpis ni el resto de charts que el backend no recalculó.
export function mergeCharts(state, charts) {
    if (!state.dashboard) {
        return
    }

    state.dashboard = {
        ...state.dashboard,
        charts: {
            ...state.dashboard.charts,
            ...charts
        }
    }
}

export function setTheme(state, theme) {
    state.theme = theme
    saveTheme(theme)
}

export function setLoading(state, loading) {
    state.loading = loading
}

export function setRefreshing(state, refreshing) {
    state.refreshing = refreshing
}

export function setFilterLoading(state, loading) {
    state.filterLoading = loading
}

// Reemplaza la lista completa de filtros activos ([{type, id, label}], uno por tipo — ver
// applyFilter() en actions.js, que es quien arma la lista combinada).
export function setFilters(state, filters) {
    state.filters = filters
}

export function clearFilters(state) {
    state.filters = []
}



// WEBPACK FOOTER //
// ./src/modules/dashboard-sale-indicators/mutations.js